import React, { useState, useEffect } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { IconButton, Modal, Tooltip } from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Chip,
} from "@mui/material";
import {
  Cross,
  LeftArrowDouble,
  RightArrow,
} from "../../../shared/assets/icons";
import EditIcon from "@mui/icons-material/Edit";
import Styles from "../../../styles/vendorDashboard.module.css";
import CommentModal from "../../../shared/createForms/CommentModal";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CommentIcon from "@mui/icons-material/Comment";

import axios from "axios";
import Delete from "@mui/icons-material/Delete";
import GlobalSnackbar from "../../../shared/utils/GlobalSnackbar";
import ReasonModal from "../../../shared/createForms/ReasonModal";
import GlobalButton from "../../../shared/utils/GlobalButton";

const VendorDialog = ({
  selectedVendorData,
  setIsVendorModalOpen,
  isVendorModalOpen,
  setSelectedVendorData,
  setSnackbar,
  snackbar,
  setAnchorEl,
  fetchFilteredVendors,
}) => {
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [commentModal, setCommentModal] = useState(false);
  const [reasonModal, setReasonModal] = useState(false);
  const [editReason, setEditReason] = useState("");
  const [comment, setComment] = useState("");
  const [allComments, setAllComments] = useState([]);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editCommentText, setEditCommentText] = useState("");

  const [loading, setCommentLoading] = useState(false);
  const serverURL = process.env.REACT_APP_URL;
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleClose = () => {
    setIsVendorModalOpen(false);
    setSelectedVendorData({});
  };

  // const handleImageClick = (index) => {
  //   setCurrentIndex(index);
  //   setIsImagePreviewOpen(true);
  // };

  const handleCloseImagePreview = () => {
    setIsImagePreviewOpen(false);
  };

  const handlePrevious = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex < selectedVendorData?.imagesUploaded?.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };
  const handleSubmit = async () => {
    if (!comment.trim() && !editCommentText.trim()) {
      setSnackbar({
        open: true,
        message: "Comment cannot be empty",
        severity: "warning",
      });
      return;
    }

    setCommentLoading(true);

    try {
      if (editingCommentId) {
        // EDIT existing comment
        const response = await axios.put(
          `${serverURL}/api/editComment/${editingCommentId}`,
          { comment: editCommentText },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        if (response.data.success) {
          setSnackbar({
            open: true,
            message: "Comment updated successfully",
            severity: "success",
          });
          fetchComments();
          setEditingCommentId(null);
          setEditCommentText("");
          setComment("");
          setCommentModal(false);
        }
      } else {
        // ADD new comment
        const response = await axios.post(
          `${serverURL}/api/comment/${selectedVendorData._id}`,
          { comment, userId: localStorage.getItem("userId") },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        if (response.data.success) {
          setSnackbar({
            open: true,
            message: "Comment added successfully",
            severity: "success",
          });
          fetchComments();
          setComment("");
          setCommentModal(false);
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: editingCommentId
          ? "Error updating comment"
          : "Error adding comment",
        severity: "error",
      });
    } finally {
      setCommentLoading(false);
      setComment("");
      setEditCommentText("");
    }
  };
  const handleSaveEditReason = async () => {
    if (!editReason.trim()) {
      setSnackbar({
        open: true,
        message: "Reason is required to blacklist.",
        severity: "error",
      });
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const payLoad = {
        status: -2,
        reason: editReason,
      };

      const response = await axios.put(
        `${serverURL}/api/updateStatus/${selectedVendorData._id}`,
        payLoad,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setSnackbar({
          open: true,
          message: "Vendor blacklisted reason update successfully",
          severity: "success",
        });

        setReasonModal(false);
        setEditReason("");
        setIsVendorModalOpen(false);
        const queryParams = new URLSearchParams();
        queryParams.append("page", 1);
        queryParams.append("limit", 10);
        queryParams.append("adminApproval", -2);
        await fetchFilteredVendors(queryParams);
      }
    } catch (error) {
      console.error("Blacklist error:", error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || "Error blacklisting vendor",
        severity: "error",
      });
    } finally {
      setReasonModal(false);
    }
  };

  const fetchComments = async () => {
    if (!selectedVendorData?._id) return;
    try {
      const response = await axios.get(
        `${serverURL}/api/viewComment/${selectedVendorData._id}`,

        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.data.success) {
        setAllComments(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (selectedVendorData && Array.isArray(selectedVendorData.comments)) {
      setAllComments([...selectedVendorData.comments]);
    } else if (selectedVendorData && selectedVendorData._id) {
      fetchComments();
    } else {
      setAllComments([]);
    }
    setEditReason(selectedVendorData.reasonForBlacklisted);
  }, [selectedVendorData]);

  const handleCloseCommentModal = () => {
    setCommentModal(false);
    setEditingCommentId(null);
    setEditCommentText("");
    setComment("");
  };
  const handleCloseReasonModal = () => {
    setReasonModal(false);
  };
  let role = localStorage.getItem("role");

  const basicInfo = [
    {
      label: "GSTIN",
      value:
        role != 1
          ? selectedVendorData?.GSTIN?.slice(0, 16) || "Not Available"
          : "******" + selectedVendorData?.GSTIN?.slice(-3),
    },
    { label: "State", value: selectedVendorData.state || "Not Available" },
    {
      label: "District",
      value: selectedVendorData.district || "Not Available",
    },
    { label: "City", value: selectedVendorData.city || "Not Available" },
    {
      label: "Vendor Business Name",
      value:
        role != "1"
          ? selectedVendorData.vendorBusinessName || "Not Available"
          : "******" + selectedVendorData.vendorBusinessName?.slice(-3),
    },
    { label: "Pin Code", value: selectedVendorData.pinCode || "Not Available" },
    {
      label: "Type of Business",
      value: selectedVendorData.typeOfBusiness || "Not Available",
    },
    // { label: "PAN No", value: selectedVendorData.panNo || "Not Available"  },
  ];

  const businessAddress = [
    {
      label: "Owner Name",
      value: selectedVendorData?.ownerName,
    },
    {
      label: "Owner Primary Contact No",
      value:
        selectedVendorData?.ownerPrimaryContactNo?.slice(0, 16) ||
        "Not Available",
    },
    {
      label: "Owner Secondary Contact No",
      value: selectedVendorData.ownerSecondaryContactNo || "Not Available",
    },
    {
      label: "Business Address",
      value: selectedVendorData.address || "Not Available",
    },
    {
      label: "Business Location",
      value: selectedVendorData.businessLocation || "Not Available",
    },
    { label: "Website", value: selectedVendorData.website || "Not Available" },
    {
      label: "Email",
      value: selectedVendorData.emailAddress || "Not Available",
    },
  ];

  const otherDetails = [
    {
      label: "Reliability",
      value: selectedVendorData.reliability || "Not Available",
    },
    {
      label: "Total Years in Business",
      value: selectedVendorData.yearsInBusiness || "Not Available",
    },
    {
      label: "No. of Employees",
      value: selectedVendorData.numberOfEmployees || "Not Available",
    },
    {
      label: "No. of Skilled Manpower",
      value: selectedVendorData.numberOfSkilledManpower || "Not Available",
    },
    {
      label: "No. of unSkilled Manpower",
      value: selectedVendorData.numberOfUnskilledManpower || "Not Available",
    },
    {
      label: "Registered in ESI/PF",
      value: selectedVendorData.registeredInESIPF
        ? "Yes"
        : "No" || "Not Available",
    },
    ...(role != 1
      ? [
          {
            label: "Bank Account No",
            value: selectedVendorData.bankAccountNumber || "Not Available",
          },
          {
            label: "Bank Name",
            value: selectedVendorData.bankName || "Not Available",
          },
          {
            label: "IFSC Code",
            value: selectedVendorData.bankIFSCCode || "Not Available",
          },
        ]
      : []),

    {
      label: "Avg. Turnover in Lakhs",
      value: selectedVendorData.avgTurnoverLast3Years || "Not Available",
    },
    {
      label: "Production Area in Sq. Ft",
      value: selectedVendorData.productionArea || "Not Available",
    },
    {
      label: "Factors That Will Help You Scale",
      value: Array.isArray(selectedVendorData.scalingFactors)
        ? selectedVendorData.scalingFactors.join(", ")
        : selectedVendorData.scalingFactors || "Not Available",
    },

    ...(role != 1
      ? [
          // {
          //   label: "Audit Status",
          //   value: selectedVendorData.auditStatus || "Not Available",
          // },
          {
            label: "Added By",
            value: selectedVendorData.addedBy?.name || "Not Available",
          },
        ]
      : []),
    {
      label: "Credit Limit",
      value: selectedVendorData.creditLimit || "Not Available",
    },
    // {
    //   label: "Vendor Status",
    //   value: selectedVendorData.status || "Not Available",
    // },

    // If adminApproval is -2 (Blacklisted), show reason for blacklist
    // ...(selectedVendorData.adminApproval === -2 &&
    // selectedVendorData.reasonForBlacklisted
    //   ? [
    //       {
    //         label: "Reason For Blacklisted",
    //         value: selectedVendorData.reasonForBlacklisted || "Not Available",
    //       },
    //     ]
    //   : []),

    // If adminApproval is 1 (Approved) or -1 (Rejected), show approval/rejection reason
    ...([1, -1].includes(selectedVendorData.adminApproval) &&
    selectedVendorData.adminApprovalReason
      ? [
          {
            label:
              selectedVendorData.adminApproval === 1
                ? "Admin Approval Reason"
                : "Admin Rejected Reason",
            value: selectedVendorData.adminApprovalReason || "Not Available",
          },
        ]
      : []),

    {
      label: "Aadhaar Number",
      value: selectedVendorData.aadhaarCardNumber || "Not Available",
    },
    {
      label: "PAN Number",
      value: selectedVendorData.PANNumber || "Not Available",
    },
  ];

  const renderSection = (title, data) => (
    <div>
      <h3 className="text-xl font-bold text-gray-600 mb-4">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {data.map((item, index) => {
          return (
            <div key={index} className="flex flex-col">
              <Tooltip>
                <span className="font-bold text-gray-600">{item.label}:</span>
              </Tooltip>
              {(() => {
                let formattedValue;

                if (item.label === "GSTIN") {
                  formattedValue = item.value?.toUpperCase();
                } else if (item.label.toLowerCase().includes("email")) {
                  formattedValue = item.value?.toLowerCase();
                } else {
                  formattedValue = item.value
                    ?.toString()
                    ?.split(" ")
                    ?.map(
                      (word) =>
                        word.charAt(0).toUpperCase() +
                        word?.slice(1).toLowerCase(),
                    )
                    ?.join(" ");
                }

                const shouldTruncate = formattedValue?.length > 50;
                const displayText = formattedValue
                  ? shouldTruncate
                    ? formattedValue?.slice(0, 50) + "..."
                    : formattedValue
                  : "Not Available";

                return shouldTruncate ? (
                  <Tooltip
                    title={formattedValue || "Not Available"}
                    arrow
                    placement="top"
                  >
                    <span className="text-gray-600 break-words">
                      {displayText}
                    </span>
                  </Tooltip>
                ) : (
                  <span className="text-gray-600 break-words">
                    {displayText}
                  </span>
                );
              })()}
            </div>
          );
        })}
      </div>
    </div>
  );

  const renderProductPricing = () => (
    <div>
      <h3 className="text-xl font-bold text-gray-600 mb-4">Product Pricing</h3>

      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border px-4 py-2">Category</th>
              <th className="border px-4 py-2">Product Type</th>
              <th className="border px-4 py-2">Unit</th>
              <th className="border px-4 py-2">Rate</th>
            </tr>
          </thead>

          <tbody>
            {selectedVendorData?.productRate?.length > 0 ? (
              selectedVendorData.productRate.map((item) => (
                <tr key={item._id}>
                  <td className="border px-4 py-2">{item.category}</td>
                  <td className="border px-4 py-2">{item.productType}</td>
                  <td className="border px-4 py-2 text-center">{item.unit}</td>
                  <td className="border px-4 py-2 text-center">
                    ₹ {item.rate}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="4"
                  className="border px-4 py-2 text-center text-gray-500"
                >
                  No Product Pricing Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [vendoruploadedFiles, setVendorUploadedFiles] = useState([]);

  // Automatically update state whenever `selectedVendorData` changes
  useEffect(() => {
    if (selectedVendorData?.imagesUploaded?.length > 0) {
      setUploadedFiles([...selectedVendorData.imagesUploaded]); // Copy images to state
    } else {
      setUploadedFiles([]);
    }
    if (selectedVendorData?.vendorimagesUploaded?.length > 0) {
      setVendorUploadedFiles([...selectedVendorData.vendorimagesUploaded]); // Copy images to state
    } else {
      setUploadedFiles([]);
    }
  }, [selectedVendorData]);

  const [isImageModalOpen, setIsImageModalOpen] = useState(false); // Modal visibility state
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // Current image index
  const [currentImageType, setCurrentImageType] = useState("uploaded");
  // or "vendor" depending on the image set being viewed

  const [selectedImage, setSelectedImage] = useState(null); // Selected image state
  const [vendorId, setVendorId] = useState(null);
  const handleCommentClick = (e, v) => {
    setCommentModal(true);
    setVendorId(v);
    setAnchorEl(null);
  };
  // const openImageModal = (index) => {
  //   setSelectedImage(uploadedFiles[index]); // Set the selected image
  //   setCurrentImageIndex(index); // Set the current image index
  //   setIsImageModalOpen(true); // Open the modal
  // };

  // const closeImageModal = () => {
  //   setIsImageModalOpen(false); // Close the modal
  //   setSelectedImage(null); // Clear selected image
  // };

  // const handleNextImage = () => {
  //   const nextIndex = (currentImageIndex + 1) % uploadedFiles.length; // Loop back to the first image if at the end
  //   setCurrentImageIndex(nextIndex);
  //   setSelectedImage(uploadedFiles[nextIndex]);
  // };

  // const handlePrevImage = () => {
  //   const prevIndex =
  //     (currentImageIndex - 1 + uploadedFiles.length) % uploadedFiles.length; // Loop back to the last image if at the beginning
  //   setCurrentImageIndex(prevIndex);
  //   setSelectedImage(uploadedFiles[prevIndex]);
  // };

  const openImageModal = (index, type = "uploaded") => {
    setCurrentImageType(type);
    const images = type === "uploaded" ? uploadedFiles : vendoruploadedFiles;
    setSelectedImage(images[index]);
    setCurrentImageIndex(index);
    setIsImageModalOpen(true);
  };
  const closeImageModal = () => {
    setIsImageModalOpen(false);
    setSelectedImage(null);
    setCurrentImageIndex(0);
    setCurrentImageType("uploaded"); // reset or leave as is
  };
  const handleNextImage = () => {
    const images =
      currentImageType === "uploaded" ? uploadedFiles : vendoruploadedFiles;
    const nextIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(nextIndex);
    setSelectedImage(images[nextIndex]);
  };

  const handlePrevImage = () => {
    const images =
      currentImageType === "uploaded" ? uploadedFiles : vendoruploadedFiles;
    const prevIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(prevIndex);
    setSelectedImage(images[prevIndex]);
  };

  const handleDelete = async (commentId) => {
    try {
      const response = await axios.delete(
        `${serverURL}/installationPartner/deleteComment/${commentId}`,

        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      fetchComments();
    } catch (error) {
      console.error(error);
    }
  };

  const handleEditComment = (commentId, currentComment) => {
    setEditingCommentId(commentId);
    setEditCommentText(currentComment);
    setCommentModal(true); // Open the modal
  };

  const [selectedImageFab, setSelectedImageFab] = useState(null);
  const [isImage, setIsImage] = useState(false);

  const handleImageClickFab = (imageSrc) => {
    setSelectedImageFab(imageSrc); // Set the clicked image's source
    // Show the modal
    setIsImage(true);
  };

  return (
    <>
      {/* Main Dialog for Vendor Details */}
      <Dialog
        open={isVendorModalOpen}
        onClose={handleClose}
        fullWidth
        maxWidth="2xl" // Available options: 'xs', 'sm', 'md', 'lg', 'xl'
      >
        <div className={`flex justify-between ${Styles.vendorModalColor}`}>
          <DialogTitle className={Styles.vendorHeading}>
            Vendor Profile Details
          </DialogTitle>
          <div
            onClick={handleClose}
            className="mx-5 my-4"
            style={{ cursor: "pointer" }}
          >
            <Cross />
          </div>
        </div>
        <DialogContent className={Styles.vendorModalColor}>
          <Box>
            <div className="min-h-screen flex flex-col md:flex-row relative">
              {selectedVendorData?.adminApproval == "-2" && (
                <div
                  className="
      absolute inset-0 flex justify-center items-start md:top-[250px] lg:top-[270px] 2xl:top-[450px]
      pointer-events-none
    "
                >
                  <span
                    className="
        text-red-600
        text-4xl md:text-[8rem] lg:text-[10rem] 2xl:text-[16rem]
        font-bold
        opacity-20
        rotate-[330deg]
        select-none
      "
                  >
                    BLACKLISTED
                  </span>
                </div>
              )}
              {/* Sidebar */}
              <aside className="w-full md:w-1/4  md:mb-0 md:mr-4 ">
                {/* Profile Photo Information */}
                <div className="text-center mb-6 bg-white rounded-lg shadow-md p-6">
                  {selectedVendorData?.profilePhoto ? (
                    <img
                      src={selectedVendorData.profilePhoto}
                      alt="Profile Logo"
                      className="w-24 h-24 rounded-full mx-auto mb-4 cursor-pointer object-cover"
                      onClick={() => {
                        const url = selectedVendorData?.profilePhoto
                          ? selectedVendorData.profilePhoto
                          : "/assets/AdminDashboard/vendorImg.jpg";
                        console.log("URL passed:", url);
                        handleImageClickFab(url);
                      }}
                    />
                  ) : (
                    <div className="w-24 h-24 rounded-full mx-auto mb-4 flex items-center justify-center bg-gray-200 cursor-pointer">
                      <p className="text-gray-400 text-3xl font-bold">
                        {selectedVendorData?.ownerName
                          ?.split(" ")
                          ?.slice(0, 1)
                          .map((word) => word.charAt(0).toUpperCase())
                          .join("") || "Not Available"}
                      </p>
                    </div>
                  )}
                  {(() => {
                    const formattedName = selectedVendorData?.ownerName
                      ?.split(" ")
                      ?.map(
                        (word) =>
                          word.charAt(0).toUpperCase() +
                          word?.slice(1).toLowerCase(),
                      )
                      ?.join(" ");

                    const shouldTruncate = formattedName?.length > 16;
                    const displayText = formattedName
                      ? shouldTruncate
                        ? formattedName?.slice(0, 16) + "..."
                        : formattedName
                      : "Not Available";

                    return shouldTruncate ? (
                      <Tooltip
                        title={formattedName || "Not Available"}
                        arrow
                        placement="top"
                      >
                        <h2 className="text-xl font-semibold">{displayText}</h2>
                      </Tooltip>
                    ) : (
                      <h2 className="text-xl font-semibold">{displayText}</h2>
                    );
                  })()}

                  {/* <p className="text-gray-500">
                    {selectedVendorData?.status === "Active" ? (
                      <Chip
                        label="Active"
                        sx={{ backgroundColor: "#D0F4FF", color: "#093EBC" }}
                      />
                    ) : selectedVendorData?.status === "Blacklisted" ? (
                      <Chip
                        label="Blacklisted"
                        sx={{ backgroundColor: "#FFDFDF", color: "#8C0909" }}
                      />
                    ) : (
                      <Chip
                        label="Inactive"
                        sx={{ backgroundColor: "#FBF5C4", color: "#885401" }}
                      />
                    )}
                  </p> */}
                </div>
                {localStorage.getItem("role") === "-1" && (
                  <div className="mb-6 bg-white rounded-lg shadow-md p-6 max-h-[300px] overflow-y-auto">
                    <section className="flex justify-between items-center mb-3">
                      <h3 className="text-[#04ADE6] font-semibold mb-4">
                        Comments
                      </h3>
                      <Tooltip title="Add Comment" arrow>
                        <div
                          onClick={(e) =>
                            handleCommentClick(e, selectedVendorData._id)
                          }
                          className="cursor-pointer mb-2 flex items-center justify-center border bg-[#66d4f8] shadow-sm h-8 w-8 rounded-full hover:bg-gray-200"
                        >
                          <span className="text-gray-800 text-[25px]">+</span>
                        </div>
                      </Tooltip>
                    </section>

                    <ul className="space-y-4 pr-2 ">
                      {allComments?.length > 0 ? (
                        allComments.map((ele, index) => (
                          <li
                            key={ele._id || index}
                            className="border-b pb-3 bg-gray-100 p-2 rounded-md shadow-md"
                          >
                            <div className="flex items-start justify-start relative gap-2">
                              <IconButton
                                size="small"
                                sx={{
                                  position: "absolute",
                                  top: -20,
                                  right: 4,
                                }}
                                onClick={() => {
                                  setCommentModal(true);
                                  handleEditComment(ele?._id, ele?.comment);
                                }}
                              >
                                <EditIcon fontSize="small" color="primary" />
                              </IconButton>
                              <IconButton
                                size="small"
                                sx={{
                                  position: "absolute",
                                  top: -20,
                                  right: -18,
                                }}
                                onClick={() => handleDelete(ele?._id)}
                              >
                                <Delete fontSize="small" color="error" />
                              </IconButton>

                              <CommentIcon
                                style={{
                                  color: "#04ADE6",
                                  fontSize: "15px",
                                  marginTop: "6px",
                                }}
                              />
                              <p className="text-gray-700 text-sm italic flex items-center gap-2 whitespace-pre-line">
                                {ele?.comment}
                              </p>
                            </div>
                            <div className="text-[12px] text-gray-500 mt-1 text-right mr-2">
                              Commented by{" "}
                              <span className="font-semibold text-gray-600">
                                {ele?.commentedBy?.name
                                  .charAt(0)
                                  .toUpperCase() +
                                  ele?.commentedBy?.name?.slice(1) || "Unknown"}
                              </span>
                              <br />
                              <span className="text-[11px]">
                                <CalendarTodayIcon
                                  style={{
                                    color: "#04ADE6",
                                    fontSize: "13px",
                                    marginBottom: "1px",
                                  }}
                                />{" "}
                                {new Date(ele?.updatedAt).toLocaleDateString(
                                  "en-IN",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  },
                                )}
                              </span>
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className="text-gray-400 italic">
                          No comments yet.
                        </li>
                      )}
                    </ul>
                  </div>
                )}
                {selectedVendorData?.adminApproval == -2 && (
                  <div className="mb-6 bg-white rounded-lg shadow-md p-6 max-h-[300px] overflow-y-auto">
                    <section className="flex justify-between items-center mb-3">
                      <h3 className="text-[#04ADE6] font-semibold">
                        Blacklisted Reason
                      </h3>
                      {localStorage.getItem("role") == -1 && (
                        <IconButton
                          size="small"
                          onClick={() => {
                            setReasonModal(true);
                          }}
                        >
                          <EditIcon fontSize="small" color="primary" />
                        </IconButton>
                      )}
                    </section>

                    <div className="flex items-start justify-start relative gap-2">
                      <p className="text-gray-700 text-sm  flex items-center gap-2 ">
                        {/* {comment} */}
                        {selectedVendorData?.reasonForBlacklisted ||
                          "Not Available"}
                      </p>
                    </div>
                  </div>
                )}
                {/* Work Experience */}
                <div className="mb-6 bg-white rounded-lg shadow-md p-6 mb-4">
                  <h3 className="text-[#04ADE6] font-semibold mb-4">
                    Work Experience
                  </h3>
                  <ul>
                    <li className="mb-4">
                      <div className="flex justify-between">
                        <span className="text-sm font-bold">
                          Experience In Business
                        </span>
                        <p className="text-gray-500">
                          {selectedVendorData.yearsInBusiness ||
                            "Not Available"}
                        </p>
                      </div>
                    </li>
                    <li className="mb-4">
                      <div className="flex justify-between">
                        <span className="text-sm font-bold">
                          Avg. turnover in lakhs
                        </span>
                        <p className="text-gray-500">
                          {selectedVendorData.avgTurnoverLast3Years ||
                            "Not Available"}
                        </p>
                      </div>
                      <p className="text-gray-500 italic">Last 3 years</p>
                    </li>
                  </ul>
                </div>
              </aside>

              {/* Main Content */}
              <main className="w-full md:w-3/4">
                <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                  {renderSection("Basic Information", basicInfo)}
                </div>
                {role != 1 ? (
                  <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                    {renderSection("Contact Details", businessAddress)}
                  </div>
                ) : (
                  <></>
                )}
                <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                  {renderSection("Other Details", otherDetails)}
                </div>

                {/* Product Price Details */}
                {(localStorage.getItem("role") != 3 ||
                  selectedVendorData.adminApproval == 1) && (
                  <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                    {renderProductPricing()}
                  </div>
                )}

                {/* {(localStorage.getItem("role") != 3 ||
                  selectedVendorData.adminApproval == 1) && (
                  <> */}
                {/* fabrication */}
                {selectedVendorData.fabricationMachines.length > 0 && (
                  <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                    <div>
                      <h3 className="text-xl font-bold  text-gray-600 mb-4">
                        Fabrication Details
                      </h3>
                      <div
                        className={`grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-h-[400px] overflow-scroll overflow-x-hidden ${Styles["custom1-scrollbar"]}`}
                      >
                        {selectedVendorData.fabricationMachines.map(
                          (item, index) => {
                            return (
                              <div
                                key={index}
                                className="relative rounded-xl bg-white p-6 shadow-lg"
                              >
                                <h2 className="text-xl font-bold mt-6 mb-2">
                                  {item.category}
                                </h2>
                                <div className="flex justify-between items-center gap-1">
                                  <div>
                                    {" "}
                                    {item.subCategory && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Sub Category:</strong>{" "}
                                        {item.subCategory}
                                      </p>
                                    )}{" "}
                                    {item.machineThickness && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Thickness:</strong>{" "}
                                        {item.machineThickness}
                                      </p>
                                    )}{" "}
                                    {item.powerOfMachine && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Power:</strong>{" "}
                                        {item.powerOfMachine + " kW"}
                                      </p>
                                    )}{" "}
                                    {item.modelMachine && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Model:</strong>{" "}
                                        {item.modelMachine}
                                      </p>
                                    )}{" "}
                                    {item.machineMaterial && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Material:</strong>{" "}
                                        {item.machineMaterial}
                                      </p>
                                    )}{" "}
                                    {item.machineType && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Type:</strong>{" "}
                                        {item.machineType}
                                      </p>
                                    )}{" "}
                                    {item.lengthFoot && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Length:</strong>{" "}
                                        {item.lengthFoot}
                                        {"feet "}{" "}
                                        {item?.lengthInches &&
                                          item.lengthInches + " inches"}
                                      </p>
                                    )}{" "}
                                    {item.breadthFoot && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Breadth:</strong>{" "}
                                        {item.breadthFoot}
                                        {"feet "}{" "}
                                        {item?.breadthInches &&
                                          item.breadthInches + " inches"}
                                      </p>
                                    )}{" "}
                                    {item.horsepower && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Horse Power:</strong>{" "}
                                        {item.horsepower}
                                      </p>
                                    )}
                                    {item.machineSize && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Size:</strong>{" "}
                                        {item.machineSize} {"inches "}
                                      </p>
                                    )}
                                    {item.numMachines && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>No of Machine:</strong>{" "}
                                        {item.numMachines}
                                      </p>
                                    )}
                                    {item.machineLength && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Length:</strong>{" "}
                                        {item.machineLength}
                                      </p>
                                    )}
                                    {item.machineBreadth && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Breadth:</strong>{" "}
                                        {item.machineBreadth}
                                      </p>
                                    )}
                                    {item.wattage && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Wattage:</strong>{" "}
                                        {item.wattage}
                                      </p>
                                    )}
                                    {item.ageOfMachine && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Age Of Machine:</strong>{" "}
                                        {item?.ageOfMachine}
                                        {" yrs"}
                                      </p>
                                    )}
                                    {item.ampereOfMachine && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Ampere:</strong>{" "}
                                        {item.ampereOfMachine}
                                      </p>
                                    )}
                                    {item.controllerSetting && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Controller Settings:</strong>{" "}
                                        {item.controllerSetting}
                                      </p>
                                    )}
                                    {item.machineBrand && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Brand:</strong>{" "}
                                        {item.machineBrand}
                                      </p>
                                    )}
                                  </div>
                                  <div className="">
                                    {item.fabricationMachineImage && (
                                      <div>
                                        <div className="flex justify-between gap-1 items-center">
                                          <div className="flex justify-center items-center">
                                            <img
                                              className={`object-cover rounded-lg w-28 h-24 ${Styles.vendorSectionImg} cursor-pointer`}
                                              src={item.fabricationMachineImage}
                                              alt="Machine"
                                              onClick={() =>
                                                handleImageClickFab(
                                                  item.fabricationMachineImage,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          },
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <Modal
                  open={isImage}
                  onClose={() => {
                    setIsImage(false);
                    setSelectedImageFab(null);
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div className="lg:h-full flex justify-center items-center mx-auto relative">
                    <div onClick={(e) => e.stopPropagation()}>
                      <img
                        src={selectedImageFab}
                        alt="Machine"
                        className="object-contain max-w-[80vw] max-h-[90vh] sm:max-h-[50vh]"
                      />
                    </div>
                  </div>
                </Modal>

                {/* printing */}
                {selectedVendorData?.printingMachines.length > 0 && (
                  <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                    <div>
                      <h3 className="text-xl font-bold  text-gray-600 mb-4">
                        Printing Details
                      </h3>
                      <div
                        className={`grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-h-[320px] overflow-scroll overflow-x-hidden ${Styles["custom1-scrollbar"]}`}
                      >
                        {selectedVendorData?.printingMachines.map(
                          (item, index) => {
                            return (
                              <div
                                key={index}
                                className="relative rounded-xl bg-white p-6 shadow-lg"
                              >
                                <h2 className="text-xl font-bold mt-6 mb-2">
                                  {item.machinePrintingType}
                                </h2>
                                <h2 className="text-xl font-bold mt-6 mb-2">
                                  {item.machinePrintingSubType}
                                </h2>

                                <div className="flex justify-between items-center gap-3 ">
                                  <div>
                                    <p className="text-gray-600 mb-1">
                                      <strong>Max. Print Size:</strong>{" "}
                                      {item.maxPrintSize}
                                    </p>

                                    {item.machineBrand && (
                                      <p className="text-gray-600 mb-1">
                                        <strong>Machine Brand:</strong>{" "}
                                        {item.machineBrand}
                                      </p>
                                    )}

                                    <p className="text-gray-600 mb-1">
                                      <strong>Date of Purchase:</strong>{" "}
                                      {item?.ageOfMachine} {" yrs"}
                                    </p>
                                    <p className="text-gray-600 mb-1">
                                      <strong>Pico Liter:</strong>{" "}
                                      {item?.picoliter}
                                    </p>

                                    {item.quantity && (
                                      <p className="text-gray-600">
                                        <strong>Quantity:</strong>{" "}
                                        {item.quantity}
                                      </p>
                                    )}
                                  </div>
                                  <div>
                                    {item.PrintingMachineImage && (
                                      <div className="flex justify-center items-center cursor-pointer">
                                        <img
                                          src={item.PrintingMachineImage}
                                          alt="Machine"
                                          className={`object-cover rounded-lg w-28 h-24 ${Styles.vendorSectionImg}`}
                                          onClick={() =>
                                            handleImageClickFab(
                                              item.PrintingMachineImage,
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          },
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {/* </>
                )} */}
                {/* product and services */}
                {selectedVendorData?.productAndServices.length > 0 && (
                  <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                    <div>
                      <h3 className="text-xl font-bold  text-gray-600 mb-4">
                        Product and Services Details
                      </h3>
                      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                        {selectedVendorData?.productAndServices.map(
                          (item, index) => {
                            return (
                              <div
                                key={index}
                                className="relative rounded-xl bg-white p-6 shadow-lg"
                              >
                                {/* Example of conditional rendering for fields */}
                                {item.fabrication && (
                                  <div className="mb-4">
                                    <p className="font-semibold">
                                      Fabrication Products: Yes
                                    </p>
                                    <p>{item.typesOfFabrication.join(", ")}</p>
                                  </div>
                                )}

                                {item.printingProducts && (
                                  <div className="mb-4">
                                    <p className="font-semibold">
                                      Printing Products : Yes
                                    </p>
                                    <p>
                                      {item.typesOfPrintingProducts.join(", ")}
                                    </p>
                                  </div>
                                )}

                                {item.paintingProducts && (
                                  <div className="mb-4">
                                    <p className="font-semibold">
                                      Painting Products : Yes
                                    </p>
                                    <p>
                                      {item.typesOfPaintingProducts.join(", ")}
                                    </p>
                                  </div>
                                )}
                              </div>
                            );
                          },
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Images */}
                {uploadedFiles?.length > 0 && (
                  <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                    <div>
                      <h3 className="text-xl font-bold  text-gray-600 mb-4">
                        Premises And Other Images
                      </h3>
                      <div className="grid">
                        <ul
                          className={`flex flex-col sm:flex-row gap-4 flex-wrap items-center justify-start max-h-[250px] overflow-scroll overflow-x-hidden ${Styles["custom1-scrollbar"]}`}
                        >
                          {uploadedFiles.map((fileUrl, index) => (
                            <li
                              key={index}
                              className="border p-3 my-2 flex items-center flex-col gap-2 cursor-pointer"
                              onClick={() => openImageModal(index, "uploaded")}
                            >
                              {/* Check if the uploaded file is an image, video, or PDF */}
                              {fileUrl.endsWith(".mp4") ||
                              fileUrl.endsWith(".mov") ? (
                                <video
                                  controls
                                  className="h-20 w-20 object-cover rounded"
                                  src={fileUrl}
                                />
                              ) : fileUrl.endsWith(".pdf") ? (
                                <embed
                                  src={fileUrl}
                                  type="application/pdf"
                                  className="h-20 w-20 object-cover rounded"
                                  title={`uploaded-${index}`}
                                />
                              ) : (
                                <img
                                  src={fileUrl}
                                  alt={`uploaded-${index}`}
                                  className="h-20 w-20 object-cover rounded"
                                />
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {selectedVendorData?.certification?.length > 0 && (
                  <div className="bg-white rounded-lg shadow-md p-6 mb-4">
                    <div>
                      <h3 className="text-xl font-bold text-gray-600 mb-4">
                        Certifications
                      </h3>
                      <div className="grid">
                        <ul
                          className={`flex flex-col sm:flex-row gap-4 flex-wrap items-center justify-start max-h-[250px] overflow-scroll overflow-x-hidden ${Styles["custom1-scrollbar"]}`}
                        >
                          {selectedVendorData?.certifications?.map(
                            (cert, index) => (
                              <li
                                key={index}
                                className="shadow-md p-3 flex flex-col items-center gap-2 cursor-pointer"
                                onClick={() => handleImageClickFab(cert?.photo)}
                              >
                                <Chip
                                  label={cert?.label}
                                  color="primary"
                                  className="m-2"
                                />
                                <div className="w-full h-40 flex items-center justify-center overflow-hidden">
                                  <img
                                    src={cert?.photo}
                                    alt={`certification-${index}`}
                                    className="max-w-full max-h-full object-contain"
                                  />
                                </div>
                              </li>
                            ),
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
                {vendoruploadedFiles?.length > 0 && (
                  <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                    <div>
                      <h3 className="text-xl font-bold  text-gray-600 mb-4">
                        Vendor Portfolio
                      </h3>
                      <div className="grid">
                        <ul
                          className={`flex flex-col sm:flex-row gap-4 flex-wrap items-center justify-start max-h-[250px] overflow-scroll overflow-x-hidden ${Styles["custom1-scrollbar"]}`}
                        >
                          {vendoruploadedFiles.map((fileUrl, index) => (
                            <li
                              key={index}
                              className="border p-3 my-2 flex items-center flex-col gap-2 cursor-pointer"
                              onClick={() =>
                                openImageModal(index, "vendorupload")
                              }
                            >
                              {/* Check if the uploaded file is an image, video, or PDF */}
                              {fileUrl.endsWith(".mp4") ||
                              fileUrl.endsWith(".mov") ? (
                                <video
                                  controls
                                  className="h-20 w-20 object-cover rounded"
                                  src={fileUrl}
                                />
                              ) : fileUrl.endsWith(".pdf") ? (
                                <embed
                                  src={fileUrl}
                                  type="application/pdf"
                                  className="h-20 w-20 object-cover rounded"
                                  title={`uploaded-${index}`}
                                />
                              ) : (
                                <img
                                  src={fileUrl}
                                  alt={`uploaded-${index}`}
                                  className="h-20 w-20 object-cover rounded"
                                />
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
                {role != 1 && selectedVendorData?.chequeBookImageURL && (
                  <div className="  bg-white rounded-lg shadow-md p-6 mb-4">
                    <div>
                      <h3 className="text-xl font-bold  text-gray-600 mb-4">
                        Cancelled Cheque
                      </h3>
                      <div className="grid">
                        <img
                          src={selectedVendorData?.chequeBookImageURL}
                          alt="Cheque Photo"
                          className="w-full m-auto h-64 mb-4 object-contain rounded cursor-pointer"
                          onClick={() => {
                            const url = selectedVendorData?.chequeBookImageURL
                              ? selectedVendorData.chequeBookImageURL
                              : "";
                            handleImageClickFab(url);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {isImageModalOpen && selectedImage && (
                  <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 transition-opacity duration-300">
                    <button
                      className="absolute top-10 md:top-[13.75rem] md:right-[7.75rem] lg:top-[1.75rem] lg:right-[13.75rem] text-white bg-black bg-opacity-70 p-2 rounded-full hover:bg-opacity-90 transition duration-200 z-50"
                      onClick={closeImageModal}
                    >
                      <CancelIcon />
                    </button>
                    <div className="relative p-4 rounded-lg w-[90%] h-[90%] md:w-[70%] md:h-[70%]  flex flex-col items-center justify-center overflow-hidden">
                      {/* <button
              className="absolute top-3 right-[0.75rem] text-white bg-black bg-opacity-70 p-2 rounded-full hover:bg-opacity-90 transition duration-200"
              onClick={closeImageModal}
            >
              <CancelIcon />
            </button> */}
                      <div className="flex justify-between items-center w-full h-full">
                        <button
                          className="bg-gray-600 text-white p-3 rounded-full shadow-md hover:bg-gray-700 hover:scale-110 transition-transform duration-200"
                          onClick={handlePrevImage}
                        >
                          <ArrowBackIosNewIcon />
                        </button>
                        <div className="flex-grow flex justify-center items-center h-full ">
                          <img
                            src={
                              selectedImage instanceof File
                                ? URL.createObjectURL(selectedImage)
                                : selectedImage
                            }
                            alt={`image-${currentImageIndex}`}
                            className="max-w-full max-h-full object-contain rounded-md border border-gray-300 shadow-sm"
                          />
                        </div>
                        <button
                          className="bg-gray-600 text-white p-3 rounded-full shadow-md hover:bg-gray-700 hover:scale-110 transition-transform duration-200"
                          onClick={handleNextImage}
                        >
                          <ArrowForwardIosIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </main>
            </div>
            <GlobalSnackbar
              snackbar={snackbar}
              handleClose={handleSnackbarClose}
            />
            {/* <table className="table-auto border-collapse w-full">
              <tbody>
                {vendorDetails.map((item, index) => (
                  <tr key={index}>
                    <td
                      className="border px-4 py-2 font-medium"
                      style={{ width: "50%" }}
                    >
                      {item.label}
                    </td>
                    <td className="border px-4 py-2">{item.value || "Not Available"}</td>
                  </tr>
                ))}
              </tbody>
            </table> */}
          </Box>
        </DialogContent>
        <DialogActions>
          <div className="w-30">
            <GlobalButton size="medium" variant="primary" onClick={handleClose}>
              {`Close`}
            </GlobalButton>
          </div>
        </DialogActions>
      </Dialog>

      {/* Dialog for Image Preview */}
      <Dialog
        open={isImagePreviewOpen}
        onClose={handleCloseImagePreview}
        maxWidth="md"
      >
        <Box className="flex items-center justify-between px-4 py-2">
          <Button
            disabled={currentIndex === 0}
            onClick={handlePrevious}
            variant="contained"
          >
            <LeftArrowDouble />
          </Button>
          <Box className="w-[500px] h-[450px] flex justify-center items-center bg-gray-100">
            {selectedVendorData?.imagesUploaded?.[currentIndex]?.endsWith(
              ".mp4",
            ) ||
            selectedVendorData?.imagesUploaded?.[currentIndex]?.endsWith(
              ".mov",
            ) ? (
              <video
                controls
                autoPlay
                src={selectedVendorData?.imagesUploaded?.[currentIndex]}
                className="w-full h-full object-cover"
              />
            ) : (
              <img
                src={selectedVendorData?.imagesUploaded?.[currentIndex]}
                alt={`preview-${currentIndex}`}
                className="w-full h-full object-cover"
              />
            )}
          </Box>
          <Button
            disabled={
              currentIndex === selectedVendorData?.imagesUploaded?.length - 1
            }
            onClick={handleNext}
            variant="contained"
          >
            <RightArrow />
          </Button>
        </Box>
      </Dialog>
      {commentModal && (
        <CommentModal
          editingCommentId={editingCommentId}
          editCommentText={editCommentText}
          setEditCommentText={setEditCommentText}
          commentModal={commentModal}
          setComment={setComment}
          loading={loading}
          comment={comment}
          handleClose={handleCloseCommentModal}
          handleSubmit={handleSubmit}
        />
      )}
      {reasonModal && (
        <ReasonModal
          open={reasonModal}
          loading={loading}
          editReason={editReason}
          setEditReason={setEditReason}
          handleClose={handleCloseReasonModal}
          handleSaveEditReason={handleSaveEditReason}
        />
      )}
    </>
  );
};

export default VendorDialog;
